enum CompareSortType {
  ATOZ = "a to z",
  HIGHTOLOW = "high to low",
  LOWTOHIGH = "low to high",
  ZTOA = "z to a",
}

export default CompareSortType;
